import { render, staticRenderFns } from "./MailSendingSummaryModal.vue?vue&type=template&id=5c56e12c&scoped=true&"
import script from "./MailSendingSummaryModal.vue?vue&type=script&lang=js&"
export * from "./MailSendingSummaryModal.vue?vue&type=script&lang=js&"
import style0 from "./MailSendingSummaryModal.vue?vue&type=style&index=0&id=5c56e12c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c56e12c",
  null
  
)

export default component.exports